import Vue from 'vue'
// import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'
// import VueMoney from 'v-money'
import VueSweetalert2 from 'vue-sweetalert2'
import * as VueGoogleMaps from 'vue2-google-maps'
import App from './App.vue'
import axiosHttp from './axios'
import router from './router'
import store from './store'
import './registerServiceWorker'

import vSelect from 'vue-select';
import Treeselect from '@riophae/vue-treeselect';
import draggable from 'vuedraggable';
import vue2Dropzone from 'vue2-dropzone';

import ClickOutside from 'vue-click-outside';

import CurrencyFilter from './shared/filters/currency';
import NumericInput from './common/NumericInput';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@/assets/css/light-bootstrap.css';
import 'font-awesome/css/font-awesome.min.css';
import '@/assets/css/nucleo-icons.css';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import '@/assets/css/app.css';

// Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueTheMask);
// Vue.use(VueMoney);
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    // key: 'AIzaSyDA6wMNRuMvKKZIZnfHVVzuyD-HDgRFoPw'
    key: 'AIzaSyDN7QmMAYg2MAx00HB_4hcyV3lhcefWUKw'
  }
});

Vue.component('v-select', vSelect);
Vue.component('treeselect', Treeselect);
Vue.component('draggable', draggable);
Vue.component('vue-dropzone', vue2Dropzone);
Vue.component('numeric-input', NumericInput);

Vue.directive('click-outside', ClickOutside);

Vue.filter('currency', CurrencyFilter);

Vue.prototype.$eventBus = new Vue();
Vue.prototype.$http = axiosHttp;

Vue.config.productionTip = false;

export const VueApp = new Vue({
  router,
  store,
  render: h => h(App),
});
VueApp.$mount('#app');
